module.exports = __webpack_public_path__ + "static/media/banner-2-1.32d9483b.jpg";